import './Recognition.css'
import { useTranslation } from 'react-i18next'

const Recognition = () => {
  const { t } = useTranslation()
  const awardsData = [
    {
      id: 1,
      imageUrl: '/assets/Recognition/gptw2021.png',
      altText: 'Great Place to Work 2020',
      title: 'recognition_page.awards.gptw2020.title',
      description: 'recognition_page.awards.gptw2020.description',
    },
    {
      id: 2,
      imageUrl: '/assets/Recognition/gptw2022.png',
      altText: 'Great Place to Work 2021',
      title: 'recognition_page.awards.gptw2021.title',
      description: 'recognition_page.awards.gptw2021.description',
    },
    {
      id: 3,
      imageUrl: '/assets/Recognition/gptw2023.png',
      altText: 'Great Place To Work 2023',
      title: 'recognition_page.awards.gptw2023.title',
      description: 'recognition_page.awards.gptw2023.description',
    },
    {
      id: 4,
      imageUrl: '/assets/Recognition/gptw2024.png',
      altText: 'Great Place To Work 2024',
      title: 'recognition_page.awards.gptw2024.title',
      description: 'recognition_page.awards.gptw2024.description',
    },
    {
      id: 5,
      imageUrl: '/assets/Recognition/gptw2025.png',
      altText: 'Great Place To Work 2025',
      title: 'recognition_page.awards.gptw2025.title',
      description: 'recognition_page.awards.gptw2025.description',
    },
    {
      id: 6,
      imageUrl: '/assets/Recognition/melhores empresas.png',
      altText: 'Great Place To Work 2021',
      title: 'recognition_page.awards.gptw2021_2.title',
      description: 'recognition_page.awards.gptw2021_2.description',
    },
    {
      id: 7,
      imageUrl: '/assets/Recognition/qlicar.png',
      altText: 'Prêmio Qlicar',
      title: 'recognition_page.awards.qlicar.title',
      description: 'recognition_page.awards.qlicar.description',
    },
    {
      id: 8,
      imageUrl: '/assets/Recognition/revelo awards.png',
      altText: 'Prêmio Revelo Awards',
      title: 'recognition_page.awards.revelo.title',
      description: 'recognition_page.awards.revelo.description',
    },
  ]

  return (
    <section className="main-container Recognition">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('recognition_page.title')}</h2>
          <p>{t('recognition_page.subtitle')}</p>
        </div>
        <div className="image-container">
          <img src="/assets/Recognition/reconhecimento top.png" alt="" />
        </div>
      </header>
      <div className="RecognitionContent">
        <div className="RecognitionContentInner">
          <h2>{t('recognition_page.content.title')}</h2>
          <p className="Principal">{t('recognition_page.content.subtitle')}</p>

          <div className="RecognitionAwards">
            {awardsData.map((award) => (
              <div className="award" key={award.id}>
                <div className="award-image">
                  <img src={award.imageUrl} alt={award.altText} />
                </div>
                <h3 className="award-title">{t(award.title)}</h3>
                <p className="award-description">{t(award.description)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Recognition
